import axios from 'axios'
import moment from 'moment'
import environment from '../environments/environment';

let BASE_URL = environment.api.host;

const AdminService = {

  getProfiles: async () => {
    const { data } = await axios.get(`${BASE_URL}/role`)
    return data.roles
  },

  createProfile: async (title, description, name) => {
    const body = {
      role: {
        name,
        title,
        description,
        // active: true
      }
    }
    const { data } = await axios.post(`${BASE_URL}/role/create`, body)
    return data.role
  },

  updateProfile: async (id, title, description, name) => {
    const body = {
      id,
      role: {
        name,
        title,
        description
      }
    }
    const { data } = await axios.put(`${BASE_URL}/role/update`, body)
    return data
  },

  deleteProfile: async id => {
    const { data } = await axios.delete(`${BASE_URL}/role/${id}`)
    return data
  },

  getUsers: async () => {
    const { data } = await axios.get(`${BASE_URL}/user`)
    return data.users
  },

  getUserUbications: async (userId) => {
    const { data: { pickupPoints } } = await axios.get(`${BASE_URL}/user/${userId}/pickup-point`)
    return pickupPoints;
  },

  createUser: async (username, password, roleId) => {
    const body = {
      user: {
        roleId,
        username,
        password,
        firstName: '',
        lastName: '',
        email: ''
      }
    }
    const { data } = await axios.post(`${BASE_URL}/user/create`, body)
    return data.user
  },

  createPickupUser: async (userId, pickupPointId) => {
    const body = {
      userPickupPoint: {
        userId,
        pickupPointId
      }
    }
    const { data } = await axios.post(`${BASE_URL}/user-pickup-point/create`, body)
    return data;
  },

  deleteUser: async id => {
    const { data } = await axios.delete(`${BASE_URL}/user/${id}`)
    return data
  },

  deletePickupUser: async (userId, pickupPointId) => {
    const { data } = await axios.delete(`${BASE_URL}/user-pickup-point/${userId}/${pickupPointId}`)
    return data;
  },

  updateUser: async (id, username, password, roleId) => {
    console.log(password, 'updateuser')
    const body = {
      id,
      user: {
        username,
        ...(password && { password }),
        roleId
      }
    }
    const { data } = await axios.put(`${BASE_URL}/user/update`, body)
    return data
  },

  updateUserPass: async (id, password) => {
    console.log(password)
    const body = {
      id,
      user: {
        password,
      }
    }
    const { data } = await axios.put(`${BASE_URL}/user/update`, body)
    return data
  },

  getPickUpPoints: async (operatorIds, carPlate) => {
    const { data } = await axios.get(`${BASE_URL}/pickup-point`, {
      params: {
        ...(carPlate && { ...carPlate }),
        operatorIds
      }
    })
    return data.pickupPoints
  },

  createPickUpPoints: async (operatorId, title, latitude, longitude, address, code) => {
    console.log(operatorId, title, latitude, longitude, address, code)
    const body = {
      pickupPoint: {
        operatorId,
        title,
        latitude: latitude || "1",
        longitude: longitude || "1",
        address,
        code
      }
    }
    const { data } = await axios.post(`${BASE_URL}/pickup-point/create`, body)
    return data.user
  },

  deletePickUpPoint: async (id) => {
    const { data } = await axios.delete(`${BASE_URL}/pickup-point/${id}`);
    return data
  },

  updatePickUpPoint: async (id, title, latitude, longitude, address, code) => {
    const body = {
      id,
      pickupPoint: {
        title,
        latitude: latitude || "1",
        longitude: longitude || "1",
        address,
        code
      }
    }
    const { data } = await axios.put(`${BASE_URL}/pickup-point/update`, body)
    return data
  },

  getOperators: async () => {
    const { data: { operators } } = await axios.get(`${BASE_URL}/operator`);
    return operators;
  },

  getOperatorsByName: async (name) => {
    try {
      const { data, status } = await axios.get(`${BASE_URL}/operator/filter?name=${name}`);
      return status === 200 ? data?.operators : [];
    } catch (error) {
      console.log({error})
    }

    return []
  },

  createOperator: async (operator) => {
    const { data } = await axios.post(`${BASE_URL}/operator/create`, {
      operator: {
        ...operator,
        countryCode: 'PE'
      }
    });
    return data;
  },

  updateOperator: async (operator) => {
    const { data } = await axios.put(`${BASE_URL}/operator/update`, {
      id: operator.id,
      operator: {
        ...operator,
        countryCode: 'PE'
      }
    });
    return data;
  },

  deleteOperator: async (id) => {
    const { data } = await axios.delete(`${BASE_URL}/operator/${id}`);
    return data;
  },

  getPlace: async pickupId => {
    const { data: { places } } = await axios.get(`${BASE_URL}/pickup-point/${pickupId}/place`);
    return places
  },

  createPlace: async (pickupPointId, name, description) => {
    console.log(pickupPointId, name, description)
    const body = {
      place: {
        pickupPointId,
        name,
        description
      }
    }
    const { data } = await axios.post(`${BASE_URL}/place/create`, body)
    return data.place
  },

  updatePlace: async (id, name, description) => {
    const body = {
      id,
      place: {
        name,
        description
      }
    }
    const { data } = await axios.put(`${BASE_URL}/place/update`, body)
    return data
  },

  deletePlace: async (id) => {
    console.log(id)
    const { data } = await axios.delete(`${BASE_URL}/place/${id}`)
    console.log(data)
    return data;
  },

  uploadExcel: async ({ file, email }, config = {}) => {
    let formData = new FormData();
    formData.append('0', file);
    formData.append('email', email);
    const { data } = await axios.post(`${BASE_URL}/excel/upload`, formData, {
      ...config,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return data;
  },

  getCuds: async ({ status = 'expired', paginate = true, currentPage = 1, perPage = 5, guideNumber, pickupPoint = [], clientDni, startDate, endDate }) => {
    // console.log(pickupPoint);
    const pickupPointId = pickupPoint.map(pp => pp.id)
    const { data } = await axios.get(`${BASE_URL}/cud`, {
      params: {
        status,
        paginate,
        currentPage,
        perPage,
        ...(guideNumber && { guideNumber }),
        ...(startDate && { startDate: moment(startDate).format('YYYY-MM-DD') }),
        ...(endDate && { endDate: moment(endDate).format('YYYY-MM-DD') }),
        ...(pickupPointId.length > 0 && { pickupPointIds: pickupPointId.join(',') }),
        ...(clientDni && { clientDni }),
      }
    })
    return data
  },

  downloadExcelCuds: async ({ guideNumber, pickupPoint = [], clientDni, startDate, endDate }) => {
    const pickupPointId = pickupPoint.map(pp => pp.id)
    const { data } = await axios.get(`${BASE_URL}/excel`, {
      params: {
        ...(guideNumber && { guideNumber }),
        ...(startDate && { startDate: moment(startDate).format('YYYY-MM-DD') }),
        ...(endDate && { endDate: moment(endDate).format('YYYY-MM-DD') }),
        ...(pickupPointId.length > 0 && { pickupPointIds: pickupPointId.join(',') }),
        ...(clientDni && { clientDni }),
      },
      responseType: 'blob',
    })
    console.log(data);
    return data
  },

  getLPNS: async ({ paginate = true, currentPage = 1, perPage = 5, orderNumber, startCreationDate, endCreationDate, startPickupDate, endPickupDate, startDispatchDate, endDispatchDate }) => {
    const { data } = await axios.get(`${BASE_URL}/mkp`, {
      params: {
        paginate,
        currentPage,
        perPage,
        ...(orderNumber && { orderNumber }),
        ...(startCreationDate && { startCreationDate: moment(startCreationDate).format('YYYY-MM-DD') }),
        ...(endCreationDate && { endCreationDate: moment(endCreationDate).format('YYYY-MM-DD') }),
        ...(startPickupDate && { startPickupDate: moment(startPickupDate).format('YYYY-MM-DD') }),
        ...(endPickupDate && { endPickupDate: moment(endPickupDate).format('YYYY-MM-DD') }),
        ...(startDispatchDate && { startDispatchDate: moment(startDispatchDate).format('YYYY-MM-DD') }),
        ...(endDispatchDate && { endDispatchDate: moment(endDispatchDate).format('YYYY-MM-DD') }),
      }
    })
    return data
  },

  downloadExcelLPN: async ({ orderNumber, startCreationDate, endCreationDate, startPickupDate, endPickupDate, startDispatchDate, endDispatchDate }) => {
    const { data } = await axios.get(`${BASE_URL}/excel/mkp`, {
      params: {
        ...(orderNumber && { orderNumber }),
        ...(startCreationDate && { startCreationDate: moment(startCreationDate).format('YYYY-MM-DD') }),
        ...(endCreationDate && { endCreationDate: moment(endCreationDate).format('YYYY-MM-DD') }),
        ...(startPickupDate && { startPickupDate: moment(startPickupDate).format('YYYY-MM-DD') }),
        ...(endPickupDate && { endPickupDate: moment(endPickupDate).format('YYYY-MM-DD') }),
        ...(startDispatchDate && { startDispatchDate: moment(startDispatchDate).format('YYYY-MM-DD') }),
        ...(endDispatchDate && { endDispatchDate: moment(endDispatchDate).format('YYYY-MM-DD') }),
      },
      responseType: 'blob',
    })
    console.log(data);
    return data
  },

  uploadExcelLPN: async ({ file, email }, config = {}) => {
    let formData = new FormData();
    formData.append('0', file);
    formData.append('email', email);
    const { data } = await axios.post(`${BASE_URL}/excel/mkp/upload`, formData, {
      ...config,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return data;
  },

  getFullCuds: async ({ textSearch, checkedOption, originOption }) => {
    console.log("textSearch", textSearch)
    console.log("checkedOption", checkedOption)
    console.log("originOption", originOption)

    const { data } = await axios.get(`${BASE_URL}/oc/full?status=completed&search=${textSearch}&option=${checkedOption}&originType=${originOption}`)
    console.log(data.purchaseOrders);
    return data.purchaseOrders
  },

  cancelCud: async (cud, username) => {
    const body = {
      cud,
      username
    }
    await axios.post(`${BASE_URL}/cud/cancel`, body)
  },

  cancelCuds: async (cuds, originType, orderNumbers, reason, username) => {
    const body = {
      cuds,
      originType,
      orderNumbers,
      reason,
      username
    }
    await axios.post(`${BASE_URL}/cud/cancel-many`, body)
  },

  getEvidences: async ({ type, cudNumber, orderNumber, dni, startDate, endDate, currentPage, perPage, pickupPointIds, originType }) => {
    const { data } = await axios.get(`${BASE_URL}/oc/evidence`, {
      params: {
        type,
        cudNumber,
        orderNumber,
        dni,
        startDate,
        endDate,
        pickupPointIds,
        currentPage,
        perPage,
        originType
      }
    })
    return data
  },

  exportEvidence: async (oc, type) => {
    const body = { ...oc, type }
    console.log(body);
    const { data } = await axios.post(`${BASE_URL}/pdf`, body, {
      responseType: 'blob'
    })
    return data
  },

  resendEmail: async (originType, orderNumber, email) => {
    try {
      const body = { originType, orderNumber, email }
      const { data } = await axios.post(`${BASE_URL}/oc/resend-confirmation-email`, body)
      console.log(data);
      return data;
    } catch (e) {
      console.log('error', e.response.data)
      return e.response.data || e;
    }
  },

  getReasons: async () => {
    try {
      const { data } = await axios.get(`${BASE_URL}/reason`)
      return data.reason;
    } catch (e) {
      console.log('error', e.response.data)
      return e.response.data || e;
    }
  }

}

export default AdminService
